/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2018 Deere & Company

import MeasurementReading from '../../state/measurement-reading';
import PropTypes from 'prop-types';
import React from 'react';
import { buildProductUseAmount } from '../../services/product';

const AmountOfUseModalBody = (props) => (
    <div className="amount-of-use-modal-body">
        <ul>
            {props.measurementReadings.map((measurementReading) => (
                <li key={measurementReading.useAmount.unit.key}>
                    {buildProductUseAmount(measurementReading.useAmount, measurementReading.date)}
                </li>
            ))}
        </ul>
    </div>
);

AmountOfUseModalBody.displayName = 'AmountOfUseModalBody';
AmountOfUseModalBody.propTypes = {
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
};

export default AmountOfUseModalBody;
